module.exports = __webpack_public_path__ + "img/padlock-icon.bf52e05c.svg";